import React from 'react'
import styles from './Input.module.css'

interface InputProps {
  label: string;
  isError?: string;
  register?: any;
  [key: string]: any;
}

export const Input: React.FC<InputProps> = ({
  label,
  isError,
  register,
  ...rest
}) => {
  return (
    <span className={styles.formGroup}>
      <label>
        {label}
        <input
          className={isError ? styles.errorInput : ""}
          {...register}
          {...rest}>
        </input>
      </label>
    </span>
  );
};
